import { FeatureStyle } from "../internal";
import { LayerEditor } from "./internal";
/**
 *
 * Extension of the LayerEditor for the editing of FrameFeatureLayer's.
 * @class FrameFeatureLayerEditor
 * @extends LayerEditor
 * @author Joel Burkhard
 *
 */
export class FrameFeatureLayerEditor extends LayerEditor {
    constructor(scene, layer, opt_options) {
        super(scene, layer, opt_options);
        //Init FeatureCollection
        const fh = this.scene.getFeatureHandler();
        const highlightlayerstyle = new FeatureStyle({
            stylename: "editcontroller_highlightlayerstyle",
            rules: [
                {
                    filter: "",
                    symbolizer: "point",
                    params: {
                        "font-marker": {
                            name: "cross",
                        },
                        size: 8,
                        stroke: [1, 1, 0, 1.0],
                    },
                },
                {
                    filter: "",
                    symbolizer: "line",
                    params: {
                        "stroke-width": 3,
                        stroke: [1, 1, 0, 1.0],
                    },
                },
                {
                    filter: "",
                    symbolizer: "polygon",
                    params: {
                        fill: [1, 1, 0, 0.4],
                    },
                },
            ],
        });
        this.featuresinsert = fh.createFeatureCollection(this.scene.getToolHandler().defaultstyles.draw, highlightlayerstyle, this._layer.layername + "_drawfc", true, true);
    }
}
//# sourceMappingURL=framefeaturelayereditor.js.map